import SecondaryButton from "../designSystem/buttons/SecondaryButton";
import Hero from "../designSystem/Hero";
import HeroBackground from "../../assets/images/home_header.jpg";
import SEO from "../designSystem/SEO";
import LightOutlinedButton from "../designSystem/buttons/LightOutlinedButton";
import LineLinkButton from "../designSystem/buttons/LineLinkButton";
import { ReactComponent as MortgageAdvice } from "../../assets/icons/mortgage_advice.svg";
import { ReactComponent as PensionAdvice } from "../../assets/icons/pension_advice.svg";
import { ReactComponent as InvestmentAdvice } from "../../assets/icons/investment_advice.svg";
import { ReactComponent as PersonalApproach } from "../../assets/icons/personal_approach.svg";
import PensionImage1 from "../../assets/images/pension_image_001.jpg";
import PensionImage2 from "../../assets/images/pension_image_002.jpg";
import { scrollToContact } from "../utils/navigation";
import FAQ from "../designSystem/FAQ";

const PensionPage = () => {
  return (
    <div>
      <SEO
        title="Pension and Retirement Advice"
        description="Understand your pensions, investments and retirement options with clear, personal pension advice from Monk Financial Planning."
        path="/pensions"
      />
      <Hero
        //         title={`Financial Clarity
        // Direction & Confidence`}
        //         subtitle="Wealth Management Solutions"
        showOverlay={true}
        // backgroundImage={HeroBackground}
        titleAlign="center"
        subtitleAlign="center"
        pageTitle="Pensions"
        title="Pension Advice"
        subtitle="Your pension could be one of your most important financial assets, so understanding how it works can help you plan for the future. We can help you understand your existing pensions, how they are invested and the options available to you as you approach retirement. Whether you’re just starting to think about retirement or already have several pension arrangements, we can help you build a clearer picture of your position."
        showButton={true}
        textAlign="center"
      ></Hero>

      <div className="background-container bg-primary-1 ">
        <div className="content-container row align-stretch gap-xxxxl py-xxl px-xxxl row-reverse row-ratio-47-63">
          <div className="column gap-l">
            <LineLinkButton children="pensions" />
            <h4 className="text-gray-3 uppercase">
              Prepare for the Life You Want
            </h4>
            <div className="column gap-m">
              <div className="content text-gray-3">
                Your pension is an important part of planning for later life. We
                can help you understand your existing pension arrangements, how
                your money is invested and what options may be available to you
                as you approach retirement.
              </div>
              <div className="content text-gray-3">
                Whether you have one pension or several arrangements from
                different employers, we can help you understand where you are
                now and what this could mean for your future. We’ll explain your
                options clearly and help you consider your pension alongside
                your wider financial circumstances.
              </div>
            </div>
          </div>
          <img src={PensionImage1} alt="Client planning financially for retirement" className="image-cover" />
        </div>
      </div>
      <div className="background-container bg-gray-3 ">
        <div className="content-container column align-center gap-l py-xxl px-xxxl">
          <LineLinkButton children="pensions" />
          <h4 className="uppercase text-primary-1">How we can help</h4>
          <FAQ
            items={[
              {
                question: "How Pensions Work",
                answer:
                  "We can help you understand how your pension works, including contributions, investments and the factors that can affect the value of your pension over time. Having a clear understanding of your arrangements can help you make more informed decisions about your financial future.",
              },
              {
                question: "Pension Flexibility",
                answer:
                  "There are different ways you may be able to use your pension in retirement, depending on your circumstances and pension arrangement. We can help you understand options such as taking a tax-free lump sum, drawing an income or making flexible withdrawals.",
              },
              {
                question: "Pension Investments",
                answer:
                  "Your pension is generally invested with the aim of growing your money over the long term. We can review your existing investments and help you understand how factors such as risk, potential returns, your timeframe and your wider circumstances may affect your pension.",
              },
              {
                question: "Reviewing Your Pension",
                answer:
                  "Your pension may have been set up many years ago and your circumstances may have changed since then. We can review your existing arrangements, investments and charges to help you understand whether they remain appropriate for your plans and retirement objectives.",
              },
            ]}
          />
        </div>
      </div>
      <div className="background-container bg-primary-1 ">
        <div className="content-container row align-stretch gap-xxxxl py-xxl px-xxxl row-ratio-47-63">
          <img src={PensionImage2} alt="Retired couple discussing their future plans" className="image-cover" />{" "}
          <div className="column gap-l">
            <LineLinkButton children="Planning for Retirement" />
            <h4 className="text-gray-3 uppercase">
              Looking Beyond Your Pension
            </h4>
            <div className="column gap-m">
              <div className="content text-gray-3">
                Retirement planning is about more than simply building a
                pension. It is about understanding how much you may need, how
                you could access your pension and how your income requirements
                may change throughout retirement.
              </div>
              <div className="content text-gray-3">
                We can help you consider your pension alongside your wider
                financial circumstances, including your income needs and
                retirement plans. By building a clearer picture of your
                position, we can help you understand how your pension could
                support you throughout your retirement and the options available
                to you.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="background-container bg-gray-1 ">
        <div className="content-container py-xxl px-xxxl column gap-l align-center">
          <LineLinkButton onClick={scrollToContact} children="Contact Us" />
          <h4 className=" text-gray-3 uppercase">Ready to talk?</h4>
          <div className="content text-gray-3">
            We can help you consider your pension alongside your wider financial
            circumstances to create a clearer picture of your future.
          </div>
          <SecondaryButton onClick={scrollToContact} text="MAKE AN ENQUIRY" />
        </div>
      </div>
    </div>
  );
};

export default PensionPage;
